import { ThumbUpAltRounded, ThumbDownAltRounded } from '@mui/icons-material'
import { Box, Typography, Paper, Button } from '@mui/material'
import { styled } from '@mui/system'

// ==================== Shared Styled Components ====================

export const FeedbackCard = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4.75),
    [theme.breakpoints.up('md')]: {
        minWidth: theme.spacing(72.5)
    },
    [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: 0
    }
}))

export const FeedbackOptionsWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    width: '100%',
    minHeight: theme.spacing(16),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column'
    }
}))

export const FeedbackOptionContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    cursor: 'pointer'
}))

export const IconWrapper = styled(Box, {
    shouldForwardProp: prop => prop !== 'feedbackType'
})<{ feedbackType?: 'positive' | 'negative' }>(({ theme, feedbackType }) => ({
    width: theme.spacing(6),
    height: theme.spacing(6),
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
    transition: 'all 0.2s ease',
    '&:hover': {
        backgroundColor: theme.palette.grey[100],
        color: feedbackType === 'positive'
            ? theme.palette.success.main
            : theme.palette.error.main
    }
}))

export const FeedbackLabel = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[600]
}))

export const DetailedFeedbackOptionsWrapper = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    alignItems: 'center'
}))

export const FeedbackTextGroup = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
})

export const DetailedOptionButtonsWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    justifyContent: 'center',
    width: '100%',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column'
    }
}))

export const DetailedOptionButton = styled(Button, {
    shouldForwardProp: prop => prop !== 'selected'
})<{ selected?: boolean }>(({ theme, selected }) => ({
    padding: `0 ${theme.spacing(1)}`,
    textTransform: 'none',
    backgroundColor: selected ? theme.palette.primary.main : 'transparent',
    color: selected ? theme.palette.common.white : theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    [theme.breakpoints.down('md')]: {
        width: '100%'
    }
}))

export const ThumbsUpIcon = styled(ThumbUpAltRounded)(({ theme }) => ({
    fontSize: theme.spacing(8),
    color: theme.palette.success.main,
    marginBottom: theme.spacing(1)
}))

export const ThumbsDownIcon = styled(ThumbDownAltRounded)(({ theme }) => ({
    fontSize: theme.spacing(8),
    color: theme.palette.error.main,
    marginBottom: theme.spacing(1)
}))

export const BackButton = styled(Button)(({ theme }) => ({
    alignSelf: 'flex-start',
    textTransform: 'none',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
        alignSelf: 'center'
    }
}))
